import React from 'react';

const RichTextDisplay = ({ content, className = "" }) => {
  // Функція для безпечного відображення HTML
  const createMarkup = (htmlContent) => {
    if (!htmlContent) return { __html: '' };
    return { __html: htmlContent };
  };

  // Якщо контент пустий, повертаємо заглушку
  if (!content || content.trim() === '' || content === '<p><br></p>') {
    return (
      <div className={`text-gray-500 italic ${className}`}>
        Інформація відсутня
      </div>
    );
  }

  return (
    <div
      className={`prose prose-sm max-w-none ${className}`}
      dangerouslySetInnerHTML={createMarkup(content)}
      style={{
        // Стилі для коректного відображення контенту
        lineHeight: '1.6',
        wordBreak: 'break-word'
      }}
    />
  );
};

export default RichTextDisplay;